<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="5"></Header>
    <div class="content">
      

     
        <div class="body-overlay transition-3"></div>
        <!-- extra info area end -->

        <main>
           
            <!-- slider area end -->

            <!-- page title area start -->
            <!-- <section class="page__title p-relative d-flex align-items-center" data-background="assets/img/page-title/page-title-2.jpg">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="page__title-inner text-center">
                                <h1>login</h1>
                                <div class="page__title-breadcrumb">                                 
                                    <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb justify-content-center">
                                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                        <li class="breadcrumb-item active" aria-current="page"> Login</li>
                                    </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
            <!-- page title area end -->

           <!-- contact area start -->
           <!-- <section class="contact__area pb-100 pt-95">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6">
                            <div class="contact__info">
                                <h3>Find us here.</h3>
                                <ul class="mb-55">
                                    <li class="d-flex mb-35">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-map-marker"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Address:</h6>
                                            <span>{{addressinfo.title}}</span>
                                        </div>
                                    </li>
                                    <li class="d-flex mb-35">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-envelope-open-o"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Email:</h6>
                                            <span>{{addressinfo.email}}</span>
                                        </div>
                                    </li>
                                    <li class="d-flex mb-35">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-phone"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Number Phone:</h6>
                                            <span>{{addressinfo.phone}}</span>
                                        </div>
                                    </li>
                                </ul>
                                <p v-html="addressinfo.content"></p>

                                <div class="contact__social">
                                    <ul>
                                        <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                                        <li><a href="#"><i class="fa fa-facebook-f"></i></a></li>
                                        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i class="fa fa-behance"></i></a></li>
                                        <li><a href="#"><i class="fa fa-share-alt"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div class="contact__form">
                                <h3>Contact Us.</h3> -->
                                <!-- <form action="assets/mail.php" id="contact-form">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6">
                                            <div class="contact__input">
                                                <label>Name <span class="required">*</span></label>
                                                <input type="text">
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6">
                                            <div class="contact__input">
                                                <label>Email <span class="required">*</span></label>
                                                <input type="email">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <div class="contact__input">
                                                <label>Subject <span class="required">*</span></label>
                                                <input type="text">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <div class="contact__input">
                                                <label>Message</label>
                                                <textarea cols="30" rows="10"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <div class="contact__submit">
                                                <button type="submit" class="os-btn os-btn-black">Send Message</button>
                                            </div>
                                        </div>
                                    </div>
                                </form> -->
                                <!-- <div style="margin: 20px;"></div>
                                    <el-form  label-position="top" :rules="formLabelAlign" ref="formLabelAlign" label-width="80px" :model="formLabelAlign">
                                      <el-form-item label="Name" required prop="name">
                                        <el-input v-model="formLabelAlign.name" ></el-input>
                                        
                                      </el-form-item>
                                      <el-form-item label="Email" required prop="email">
                                          <el-input v-model="formLabelAlign.email" ></el-input>
                                      </el-form-item>
                                      
                                      <el-form-item label="Subject" required prop="subject">
                                        <el-input v-model="formLabelAlign.subject"></el-input>
                                      </el-form-item>
                                      <el-form-item label="Message" prop="message">
                                        <el-input v-model="formLabelAlign.message"></el-input>
                                      </el-form-item>
                                      <el-form-item>
                                        <el-button type="primary" @click="submitForm('formLabelAlign')">立即创建</el-button>
                                       
                                      </el-form-item>
                                    </el-form>
                                <p class="ajax-response"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
            <!-- login Area Strat-->
        <section class="login-area pt-100 pb-100">
            <div class="container">
                <div class="">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="basic-login row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 formarea">
                                <h3 class="text-left">Login 登录</h3>
                                <el-form  label-position="top" :rules="rules" ref="formLabelAlign" label-width="100px" :model="formLabelAlign">
                                      <el-form-item label="Name 姓名" label-width="100px" class="text-left" required prop="name">
                                        <el-input id="name" placeholder="Enter name" v-model="formLabelAlign.name" ></el-input>
                                        
                                      </el-form-item>
                                      <el-form-item label="Password 密码" label-width="100px" class="text-left" required prop="password">
                                          <el-input id="pass" show-password placeholder="Enter password..."  type="password" v-model="formLabelAlign.password" ></el-input>
                                      </el-form-item>
                                      
                                       

                                      <el-form-item  label-width="100px" class="text-left" >
                                        <el-checkbox  v-model="checked" class="remeberPwd">remenber me</el-checkbox>
                                        <el-button :loading="logining"  class="os-btn os-btn-black w-100" @click="submitForm('formLabelAlign')">Login Now/立即登录</el-button>
                                       <!-- <el-button @click="resetForm('formLabelAlign')">重置</el-button> -->
                                      </el-form-item>
                                    </el-form>    
                            </div>
                            <div class="col-lg-1 col-md-1 col-sm-1 hidden-xs-only">
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-5 hidden-xs-only">
                                <img style="width:100%" src="../../assets/img/login/login.jpg" alt="">
                            </div>                
                            
                            
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        <!-- login Area End-->
            
        </main>

        
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
import { getlogin,getconcact } from "@/api/index/index";
export default {
  components: { Header, Footer },
  name: "home",
  data() {
    return {
      currentIndex: "",
      teacherIndex: '',
      ishove:true,
      menuctive:10,
      activeBtn: 2,
      clickIndex: 0,
      banner:'',
      lanmuhe:'',
      timeInterval: null,
      logining: false,
      // 记住密码checked
      checked: false,
      addressinfo:'',
    //   <span>New product &nbsp;|&nbsp; </span>
    //                                         <span>Discount |&nbsp; </span>
    //                                         <span>Rxpenditures </span>
      menuchoose:['New product','Discount','Expenditures'],
     formLabelAlign: {
          name: '',
          password: '',
       
        },
        rules: {
            name: [
            { required: true, message: "请输入用户名", trigger: "blur" },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            password: [
                {
                    required: true,
                    message: "密码不能为空",
                    trigger: "blur",
                },
                { min: 6, max: 10, message: '长度在 6 到 10 个字符', trigger: 'blur' }
            ],
           
          
        },
      value:'',
      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),

    };

  },
  mounted () {
    // let video = document.getElementsByClassName('video')
    // video.play()
    // 滚动条的获取
    this.getinfo()   
   
 
  },
  created(){
    //   console.log('滚动高度', window.pageYOffset)  
  },
  methods: {
    getinfo(){
        getconcact().then((res)=>{
            this.addressinfo=res.content
            this.banner=res.banner[0].image
        })    
    },
    
    addchoose(code){
        this.menuctive = code;
    },
    submitForm(formName){
      var that=this
      console.log(this.formLabelAlign)
      var form={}
      form.acount=this.formLabelAlign.name
      form.password=this.formLabelAlign.password
    
      console.log(form)
       this.$refs[formName].validate((valid) => {
        if (valid) {
            this.logining = true;
            var _this = this;
          if (_this.checked == true) {
            //存入cookie
            _this.setCookie(
              _this.formLabelAlign.name,
              _this.formLabelAlign.password,
              7
            ); //保存7天
          } else {
            _this.clearCookie();
          }

            getlogin(form).then((response) => {
               if (response.code == 1) {
                 
                this.centerDialogVisible = false;
                 this.logining = true;
                this.msgSuccess("登录成功，正在返回首页");
                sessionStorage.setItem('login',true)
                 sessionStorage.setItem('logourlshop',response.data.image)
                sessionStorage.setItem('concact',response.data.address)    
                sessionStorage.setItem('shopid',response.data.id)
                sessionStorage.setItem( 'selffetch',JSON.stringify(response.data.selffetch))     
           
                 setTimeout(() => {
                        that.$router.push({ path: "/"})
                    }, 2000);
              } else {
                this.msgError(response.msg);
                 this.logining = false;
              } 
             })
        }
       })
      
    },
    account() {
      // if (document.cookie.length <= 0) {
      console.log(this.getCookie("name"));
      this.formLabelAlign.name = this.getCookie("name");
      this.formLabelAlign.password = this.getCookie("password");
      // }
    },
    setCookie(c_name, c_pwd, exdate) {
      //账号，密码 ，过期的天数
      var exdate = new Date();
 
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdate); //保存的天数
      document.cookie =
        "name=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "password=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
    },
    getCookie(name) {
      var arr = document.cookie.split(";");
      //["_ga=GA1.1.1756734561.1561034020", " mobile=123" password=456"]
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("="); // ["_ga", "GA1.1.1756734561.1561034020"]
        if (arr2[0].trim() == name) {
          return arr2[1];
        }
      }
    },
    clearCookie() {
      this.setCookie("", "", -1); //清除cookie
    },

    changestyle(index) {
      this.currentIndex = index;
    },
    viewnews(id) {
            // this.$router.push({ name: "newsview" });
            this.$router.push({ name: "productview", query: { id } });
    },
    originstyle() {
      this.currentIndex = "";
    },
   
    changehandle (currentIndex,originIndex) {
      console.log(currentIndex,originIndex)
    },
    // 移入事件
    delHandleMouseEnter(index) {
        this.teacherIndex = index
    },
    // 移出
    delHandleMouseleave(){ 
        this.teacherIndex = ''
    }
  }
};
</script>

<style scoped lang='less'>
    .banner__area{z-index: 100;}
    .owl-carousel{display: flex;    flex-wrap: wrap;}
    .product__area .product__thumb a{display: block;}
    .col-xl-20{width:20%}
    // .col-lg-20{width:20%}
     .col-md-20{width:20%}
     .col-xs-6{width:50%}
    @media (min-width: 768px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
       
    }
    @media (min-width: 990px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
        .col-lg-20{-ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;}
       .col-xl-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
         }
    }

 

        //  .col-xl-20
    .sale__item a{display: block;}
    .banner__item{padding:10px;width:100%;background:#ccc;text-align: left;}
    .link-btn{border:2px solid #bc8246;border-radius: 10px;padding:1px 2px;text-transform: none;}
    .show-text span{cursor: pointer;}
    .show-text b{padding:1px 3px;}
    .el-button--primary{color: #ffffff;
    background-color: #323232;
    border-color: #323232;}
    .show-text .active b{background:#bc8246;border-radius: 10px;color:#fff}
    .login-area{padding-left:10px;padding-right:10px}
    .basic-login{padding:0}
    .formarea{padding:20px}
    .hidden-xs-only{padding:0;}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue